import React, { useEffect } from "react";
import Orders from "./orders";


const Audit = (props) => {
  
    return (
      <div className="container-fluid min-h-[350px]">
        <div className="rounded-xl mx-2 border-2 border-solid border-gray-400" >
          <Orders></Orders>
        </div>
      </div>
    );
  };
  
  export default Audit;